export default "__VITE_ASSET__DEGGk7dR__"